import React, { useState } from 'react';
import api from "../components/api";
import toast from 'react-hot-toast';
import { useMutation } from '@tanstack/react-query';

import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";

export type iTipoDocumentoPdf = 'G' | 'M' | 'P' | 'NP' | 'CCG';

interface iProps {
    show: boolean;
    onClose: () => void;
    tipo: iTipoDocumentoPdf;
    tituloDoc: string;
    emissao_id: number | undefined;
    cliente_id: number | undefined;
    onSuccess: (data: { link: string }) => void;
}

const EmissaoDocumentoUpload = (props: iProps) => {

    const [arquivo, setArquivo] = useState<File | undefined>();
    const [assinatura, setAssinatura] = useState<'nao' | 'sim'>('nao');

    const resetLocalState = () => {
        setArquivo(undefined);
        setAssinatura('nao');
        const fileInput = document.getElementById('arquivoDocumentoPdf') as HTMLInputElement;
        if (fileInput) fileInput.value = '';
    }

    const { mutate: enviaUpload, isPending } = useMutation({

        mutationKey: ['uploadDocumentoPdf', props.emissao_id, props.tipo],
        mutationFn: async () => {

            const formData = new FormData();
            formData.append('arquivo', arquivo as File);
            formData.append('cliente_id', String(props.cliente_id));
            formData.append('tipo', props.tipo);
            formData.append('assinatura', assinatura === 'sim' ? 'true' : 'false');

            const result = await api.post(`uploadDocumentoPdf/${props.emissao_id}`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });

            return result.data ?? {};

        },
        onSuccess: (data: any) => {

            if (data.status === 'ok') {
                toast.success(`${props.tituloDoc} enviada com sucesso!`);
                props.onSuccess(data);
                resetLocalState();
                props.onClose();
            } else {
                toast.error(data.mensagem || 'Erro ao enviar o documento.');
            }

        },
        onError: (err: any) => {

            console.log(err.response);
            toast.error(err?.response?.data?.mensagem || 'Erro ao enviar o documento.');

        }

    });

    const validaEnvia = () => {

        if (!arquivo) {
            toast.error('Por favor, selecione o arquivo PDF!');
            return;
        }

        enviaUpload();

    }

    const fechaModal = () => {
        resetLocalState();
        props.onClose();
    }

    return (
        <Dialog
            open={props.show}
            onClose={fechaModal}
            aria-labelledby="upload-documento-pdf-title"
            maxWidth="xs"
            fullWidth
        >
            <DialogTitle id="upload-documento-pdf-title">Upload - {props.tituloDoc}</DialogTitle>
            <DialogContent sx={{ display: "flex", flexDirection: "column", gap: 2 }}>

                <div className="row g-3">

                    <div className="col-md-12">
                        <label className="form-label">Arquivo *</label>
                        <input
                            type="file"
                            className="form-control"
                            accept="application/pdf"
                            id="arquivoDocumentoPdf"
                            onChange={(event) => {
                                const selectedFile = event.target.files?.[0];

                                if (selectedFile) {
                                    const fileName = selectedFile.name.toLowerCase();
                                    const fileType = selectedFile.type;

                                    if (!fileName.endsWith(".pdf") || fileType !== "application/pdf") {
                                        toast.error('Por favor, apenas arquivos no formato PDF!');
                                        return;
                                    }

                                    setArquivo(selectedFile);
                                } else {
                                    setArquivo(undefined);
                                }
                            }}
                        />
                    </div>

                    <div className="col-md-12">
                        <label className="form-label">Inserir assinatura</label>
                        <select
                            className="form-control"
                            value={assinatura}
                            onChange={(event) => setAssinatura(event.target.value as 'nao' | 'sim')}
                        >
                            <option value="nao">Não</option>
                            <option value="sim">Sim</option>
                        </select>
                    </div>

                </div>

            </DialogContent>
            <DialogActions>

                <Button color="error" variant="contained" onClick={fechaModal}>
                    Cancelar
                </Button>
                <Button color="success" variant="contained" disabled={isPending} onClick={validaEnvia}>
                    Enviar
                </Button>

            </DialogActions>
        </Dialog>
    )
}

export default EmissaoDocumentoUpload;
